import React, { useEffect, useRef, useState } from "react";
import Topbar from "../components/Topbar";
import Leftbar from "../components/Leftbar";
import { Link } from "react-router-dom";
import {
  displayError,
  displayErrorString,
  displaySuccess,
  cancelExtraPaymentRequest,
  getNriBookings,
  sendExtraPaymentRequest,
} from "../Utils/utils";
import { toggleLoader } from "../actions/loader";
import { connect } from "react-redux";
import config from "../config/config";
import axios from "axios";
import ReactPaginate from "react-paginate";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { getUserData } from "../actions/userdata";
import "../Gynac/style.css";
import "./bookings.css";

const statusClass = (status) => {
  const s = (status || '').toLowerCase();
  if (s === 'completed' || s === 'approved') return 'status-pill status-approved';
  if (s === 'cancelled' || s === 'rejected') return 'status-pill status-rejected';
  return 'status-pill status-pending';
};

const Bookings = (props) => {
  const [users, setUsers] = useState([]);
  const [count, setCount] = useState(10);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [totalBookings, setTotalBookings] = useState(0);
  const [problemModal, setProblemModal] = useState(null);
  const [playingId, setPlayingId] = useState(null);
  const audioRef = useRef(null);
  const [noteModal, setNoteModal] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [noteText, setNoteText] = useState("");
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [extraPaymentModal, setExtraPaymentModal] = useState(false);
  const [extraPaymentTarget, setExtraPaymentTarget] = useState(null);
  const [extraPaymentReason, setExtraPaymentReason] = useState('');
  const [extraPaymentAmount, setExtraPaymentAmount] = useState('');
  const [sendingExtraPayment, setSendingExtraPayment] = useState(false);
  const [cancelPaymentTarget, setCancelPaymentTarget] = useState(null);
  const [cancellingPayment, setCancellingPayment] = useState(false);

  const togglePlay = (audioUrl, id) => {
    if (playingId === id) {
      audioRef.current?.pause();
      setPlayingId(null);
    } else {
      if (audioRef.current) audioRef.current.pause();
      const newAudio = new Audio(audioUrl);
      newAudio.play().catch(() => alert("Error playing audio."));
      audioRef.current = newAudio;
      setPlayingId(id);
    }
  };
  

  const getList = async (perPage = count, pageNum = 1, searchQuery = search, status = statusFilter) => {
    props.toggleLoader(true);
    const res = await getNriBookings(perPage, pageNum, searchQuery, status);

    setTotal(res?.metadata?.totalPage);
    setTotalBookings(res?.metadata?.totalCount)
    // console.log('----------- ', res);

    setPage(res?.metadata?.page);
    setUsers(res?.data || []);
    props.toggleLoader(false);
  };

  const isFirstRun = useRef(true);
  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      getList(count, 1, search, statusFilter);
      return;
    }
    const handler = setTimeout(() => {
      getList(count, 1, search, statusFilter);
    }, 400);
    return () => clearTimeout(handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, statusFilter]);

  const deleteBooking = async () => {
    if (!deleteTarget?._id) return;
    const token = localStorage.getItem("token");
    setDeleting(true);
    props.toggleLoader(true);
    try {
      await axios.get(`${config.siteUrl}/delete-booking/${deleteTarget._id}`, {
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      });
      displaySuccess("Deleted Successfully");
      setDeleteTarget(null);
      await getList(count, page);
    } catch (error) {
      displayError(error);
    } finally {
      setDeleting(false);
      props.toggleLoader(false);
    }
  };

  const handlePageClick = async (e) => {
    const selectedPage = e.selected + 1;
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
    getList(count, selectedPage);
  };

  const handlePerPageChange = (e) => {
    const next = parseInt(e.target.value, 10);
    setCount(next);
    getList(next, 1);
  };

  const opengoogleMap = (lat, long) => {
    window.open(`https://www.google.com/maps?q=${lat},${long}`, "_blank");
  };

  const openNoteModal = (booking) => {
    setSelectedBooking(booking);
    setNoteText(booking?.note || "");
    setNoteModal(true);
  };

  const saveNote = async () => {
    try {
      const token = localStorage.getItem("token");
      await axios.post(`${config.siteUrl}/booking/update-note`,
        { booking_id: selectedBooking._id, note: noteText },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      displaySuccess("Note saved successfully");
      await getList(count, page);
      setNoteModal(false);
    } catch (err) {
      displayError(err);
    }
  };

  const openExtraPaymentModal = (booking) => {
    setExtraPaymentTarget(booking);
    setExtraPaymentReason('');
    setExtraPaymentAmount('');
    setExtraPaymentModal(true);
  };

  const closeExtraPaymentModal = () => {
    setExtraPaymentModal(false);
    setExtraPaymentTarget(null);
    setExtraPaymentReason('');
    setExtraPaymentAmount('');
  };

  const handleSendExtraPaymentRequest = async () => {
    const amt = Number(extraPaymentAmount);
    if (!extraPaymentReason.trim()) {
      displayErrorString('Please enter a reason');
      return;
    }
    if (!amt || amt <= 0) {
      displayErrorString('Please enter a valid amount');
      return;
    }
    setSendingExtraPayment(true);
    props.toggleLoader(true);
    try {
      await sendExtraPaymentRequest(extraPaymentTarget._id, extraPaymentReason.trim(), amt);
      displaySuccess('payment request sent successfully');
      closeExtraPaymentModal();
      await getList(count, page);
    } catch (err) {
      displayError(err);
    } finally {
      setSendingExtraPayment(false);
      props.toggleLoader(false);
    }
  };

  const handleCancelPaymentRequest = async () => {
    if (!cancelPaymentTarget?.requestId) return;
    setCancellingPayment(true);
    props.toggleLoader(true);
    try {
      await cancelExtraPaymentRequest(cancelPaymentTarget.requestId);
      displaySuccess('payment request cancelled');
      setCancelPaymentTarget(null);
      await getList(count, page);
    } catch (err) {
      displayError(err);
    } finally {
      setCancellingPayment(false);
      props.toggleLoader(false);
    }
  };

  
  const filteredUsers = users || [];

  // console.log('filter users  ----------' , filteredUsers);
  
  return (
    <div className="g-sidenav-show bg-gray-100">
      <div id="wrapper">
        <Leftbar />
        <main className="main-content border-radius-lg">
          <Topbar />

          <div className="header bg-primary pb-6">
            <div className="container-fluid">
              <div className="header-body">
                <div className="row align-items-center py-4">
                  <div className="col-lg-6 col-7">
                    <nav aria-label="breadcrumb" className="d-none d-md-inline-block ml-md-4">
                      <ol className="breadcrumb breadcrumb-links breadcrumb-dark">
                        <li className="breadcrumb-item"><Link to="/dashboard"><i className="fas fa-home" /></Link></li>
                        <li className="breadcrumb-item"><a href="#">Bookings</a></li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container-fluid mt--6"></div>
          <div className="container-fluid">
            <div className="card gynac-card">
              <div className="gynac-card-header">
                <h3 className="gynac-title">
                  Booking Listing
                  <span className="gynac-count-chip">
                    {totalBookings ? totalBookings : 0}{search || statusFilter !== 'all' ? ` of ${users.length}` : ''}
                  </span>
                </h3>

                <div className="gynac-toolbar">
                  <div className="gynac-search">
                    <i className="fas fa-search search-icon" />
                    <input
                      type="text"
                      placeholder="Search booking, customer, patient, service"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                  <div className="gynac-filter">
                    <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                      <option value="all">All status</option>
                      <option value="initiated">Initiated</option>
                      <option value="assigned">Assigned</option>
                      <option value="completed">Completed</option>
                      <option value="cancelled">Cancelled</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <table className="gynac-table bookings-table">
                  <colgroup>
                    <col style={{ width: '14%' }} />
                    <col style={{ width: '16%' }} />
                    <col style={{ width: '22%' }} />
                    <col style={{ width: '13%' }} />
                    <col style={{ width: '13%' }} />
                    <col style={{ width: '22%' }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>Booking</th>
                      <th>Customer</th>
                      <th>Patient & Problem</th>
                      <th>Schedule</th>
                      <th>Payment</th>
                      <th style={{ textAlign: 'center' }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredUsers.map((user) => {
                      const fullProblem = [
                        user?.service?.name,
                        user?.description,
                        user?.condition?.name,
                      ].filter(Boolean).join(', ');
                      const isLongProblem = fullProblem.length > 100;
                      const memberAddress = [
                        user?.member?.address,
                        user?.member?.city?.name,
                        user?.member?.state?.name,
                        user?.member?.pincode,
                      ].filter(Boolean).join(', ');
                      const preferredTime = moment(user?.preferred_contact_time).format('HH:mm') === 'Invalid date'
                        ? user?.preferred_contact_time
                        : moment(user?.preferred_contact_time).format('HH:mm');
                      const canAssign = user?.channel_partner_id == undefined && user?.status === 'initiated';
                      const canEdit = user?.channel_partner_id == undefined && user?.status !== 'initiated' && user?.payment_status !== 'completed';

                      return (
                        <tr key={user?._id}>
                          <td data-label="Booking">
                            <div className="booking-no">#{user?.booking_number}</div>
                            <div className="booking-pills">
                              <span className={statusClass(user?.status)} style={{ textTransform: 'capitalize' }}>{user?.status}</span>
                            </div>
                            <div className="booking-meta">
                              {user?.assigned_by && (
                                <div>
                                  <span className="meta-label">By</span>
                                  <span className="meta-value">{user.assigned_by?.first_name} {user.assigned_by?.last_name}</span>
                                </div>
                              )}
                              {user?.provider?.name && (
                                <div>
                                  <span className="meta-label">To</span>
                                  <span className="meta-value">{user.provider.name}</span>
                                </div>
                              )}
                            </div>
                          </td>

                          <td data-label="Customer">
                            <div className="customer-name">{user?.user?.full_name || '—'}</div>
                            <div className="customer-contact">
                              {user?.user?.phone_number && (
                                <div className="customer-contact-row">
                                  <i className="fas fa-phone fa-flip-horizontal" />
                                  <span>{user.user.phone_number}</span>
                                </div>
                              )}
                              {user?.user?.email && (
                                <div className="customer-contact-row">
                                  <i className="fas fa-envelope" />
                                  <a href={`mailto:${user.user.email}`} title={user.user.email}>{user.user.email}</a>
                                </div>
                              )}
                            </div>
                          </td>

                          <td data-label="Patient & Problem">
                            {user?.member?.full_name && (
                              <div className="patient-name">{user.member.full_name}</div>
                            )}
                            {memberAddress && (
                              <div className="patient-address">
                                <i className="fas fa-map-marker-alt" style={{ marginRight: 4, color: '#9aa0b4' }} />
                                {memberAddress}
                              </div>
                            )}
                            {fullProblem && (
                              <div className="patient-problem">
                                {isLongProblem ? fullProblem.slice(0, 100) + '…' : fullProblem}
                                {isLongProblem && (
                                  <span
                                    className="desc-view-more"
                                    style={{ marginLeft: 4 }}
                                    onClick={() => setProblemModal({ text: fullProblem, booking: user.booking_number })}
                                  >
                                    View More
                                  </span>
                                )}
                              </div>
                            )}
                          </td>

                          <td data-label="Schedule">
                            <div className="schedule-date">
                              {moment(user?.createdAt).format('DD MMM YYYY')}
                            </div>
                            <div className="schedule-time">
                              <i className="far fa-clock" />
                              {preferredTime}
                            </div>
                            {user?.user?.time_zone && (
                              <span className="schedule-tz">{user.user.time_zone}</span>
                            )}
                            {user?.member?.latitude && (
                              <button
                                className="schedule-location-btn"
                                onClick={() => opengoogleMap(user.member.latitude, user.member.longitude)}
                              >
                                <i className="fas fa-map-marker-alt" />
                                View Location
                              </button>
                            )}
                          </td>

                          <td data-label="Payment">
                            {user?.payment_status && (
                              <span className={statusClass(user.payment_status)} style={{ textTransform: 'capitalize' }}>
                                {user.payment_status}
                              </span>
                            )}
                            <div className="payment-amount">₹{Number(user?.total_amount ?? user?.initial_amount ?? 0).toLocaleString('en-IN')}</div>
                            {user?.discount_amount > 0 && (
                              <div className="payment-meta">
                                <span className="payment-strike">₹{Number(user?.initial_amount ?? 0).toLocaleString('en-IN')}</span>
                                <span className="payment-discount">-₹{Number(user.discount_amount).toLocaleString('en-IN')}</span>
                              </div>
                            )}
                            {user?.pay_at_hospital && (
                              <div className="payment-meta">Pay at hospital</div>
                            )}
                          </td>

                          <td data-label="Actions">
                            <div className="booking-actions">
                              <Link to={`/view-user/${user?.user_id}`} target="_blank" className="booking-actions-full">
                                <button className="booking-action-btn ba-view">
                                  <i className="fas fa-user" />
                                  View User
                                </button>
                              </Link>
                              {canAssign && (
                                <Link to={`/assign-provider?id=${user?._id}&service_id=${user?.service_id}`} className="booking-actions-full">
                                  <button className="booking-action-btn ba-assign">
                                    <i className="fas fa-user-plus" />
                                    Assign Provider
                                  </button>
                                </Link>
                              )}
                              {canEdit && (
                                <Link to={`/assign-provider?id=${user?._id}&service_id=${user?.service_id}&edit=true`} className="booking-actions-full">
                                  <button className="booking-action-btn ba-edit">
                                    <i className="fas fa-pen" />
                                    Edit Provider
                                  </button>
                                </Link>
                              )}
                              <button
                                className="booking-action-btn ba-note"
                                onClick={() => openNoteModal(user)}
                              >
                                <i className="fas fa-sticky-note" />
                                {user?.note ? 'Update' : 'Add'} Note
                              </button>
                              {(user?.payment_status === 'completed') && (
                                <button
                                  className="booking-action-btn ba-extra-payment"
                                  onClick={() => openExtraPaymentModal(user)}
                                >
                                 Payment Requests
                                </button>
                              )}
                              {user?.extra_payment_status === 'pending' && (
                                <button
                                  className="booking-action-btn ba-cancel-payment"
                                  onClick={() => {
                                    const pendingRequest = (user?.extra_payments || []).find((p) => p?.status === 'pending');
                                    setCancelPaymentTarget({
                                      requestId: pendingRequest?._id,
                                      amount: user.extra_payment_pending_amount,
                                      booking_number: user.booking_number,
                                    });
                                  }}
                                >
                                  Cancel Payment Request
                                </button>
                              )}
                              {user?.extra_payment_status === 'pending' && (
                                <div className="extra-payment-pending-badge">
                                  Payment: ₹{Number(user.extra_payment_pending_amount ?? 0).toLocaleString('en-IN')}
                                </div>
                              )}
                              {user?.extra_payment_status === 'paid' && (
                                <div className="extra-payment-paid-badge">
                                  Extra Paid: ₹{Number(user.extra_payment_paid_amount ?? 0).toLocaleString('en-IN')}
                                </div>
                              )}
                              {user?.voice_note ? (
                                <button
                                  className="booking-action-btn ba-voice"
                                  onClick={() => togglePlay(user.voice_note, user._id)}
                                >
                                  <i className={`fas ${playingId === user._id ? 'fa-pause' : 'fa-play'}`} />
                                  {playingId === user._id ? 'Pause' : 'Play'}
                                </button>
                              ) : (
                                <button className="booking-action-btn ba-voice ba-disabled" disabled>
                                  <i className="fas fa-microphone-slash" />
                                  No Voice
                                </button>
                              )}
                              <button
                                className="booking-action-btn ba-delete booking-actions-full"
                                onClick={() => setDeleteTarget(user)}
                              >
                                <i className="fas fa-trash" />
                                Delete Booking
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}

                    {!filteredUsers.length && (
                      <tr>
                        <td colSpan={6}>
                          <div className="gynac-empty">
                            <i className="fas fa-calendar-check" />
                            <div className="gynac-empty-text">No bookings found</div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {users.length > 0 && (
                <div className="gynac-footer">
                  <div className="gynac-per-page">
                    <span>Rows per page</span>
                    <select value={count} onChange={handlePerPageChange}>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                    </select>
                  </div>
                  <div className="paginate-css" style={{ margin: 0 }}>
                    <ReactPaginate
                      previousLabel="<"
                      nextLabel=">"
                      breakLabel="..."
                      pageCount={total}
                      forcePage={page > 0 ? page - 1 : 0}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName="pagination"
                      activeClassName="active"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Delete confirm modal */}
          <Modal
            show={!!deleteTarget}
            onHide={() => !deleting && setDeleteTarget(null)}
            centered
            backdrop="static"
          >
            <Modal.Header style={{ borderBottom: '1px solid #e9ecef' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ width: 40, height: 40, borderRadius: '50%', background: '#fdebec', color: '#c22627', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>
                  <i className="fas fa-exclamation-triangle" />
                </span>
                <h5 className="mb-0" style={{ fontWeight: 700 }}>Delete booking?</h5>
              </div>
              <button type="button" style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', lineHeight: 1 }} onClick={() => !deleting && setDeleteTarget(null)} disabled={deleting}>&times;</button>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px 24px', fontSize: '0.95rem', color: '#333' }}>
              Are you sure you want to delete booking{' '}
              <strong style={{ color: '#1f2540' }}>#{deleteTarget?.booking_number || ''}</strong>?
              This action cannot be undone.
            </Modal.Body>
            <Modal.Footer style={{ borderTop: '1px solid #e9ecef' }}>
              <button
                className="btn"
                style={{ background: '#fff', border: '1px solid #d0d4e0', color: '#6b7088', borderRadius: 999, fontWeight: 600, padding: '6px 18px' }}
                onClick={() => setDeleteTarget(null)}
                disabled={deleting}
              >
                Cancel
              </button>
              <button
                className="btn"
                style={{ background: '#c22627', color: '#fff', border: '1px solid #c22627', borderRadius: 999, fontWeight: 600, padding: '6px 18px', opacity: deleting ? 0.7 : 1, cursor: deleting ? 'not-allowed' : 'pointer' }}
                onClick={deleteBooking}
                disabled={deleting}
              >
                <i className="fas fa-trash" style={{ marginRight: 6, fontSize: '0.78rem' }} />
                {deleting ? 'Deleting…' : 'Delete'}
              </button>
            </Modal.Footer>
          </Modal>

          {/* Problem detail modal */}
          <Modal show={!!problemModal} onHide={() => setProblemModal(null)} centered>
            <Modal.Header style={{ borderBottom: "1px solid #e9ecef" }}>
              <h5 className="mb-0" style={{ fontWeight: 700 }}>
                Problem Details {problemModal?.booking ? `— Booking #${problemModal.booking}` : ""}
              </h5>
              <button type="button" style={{ background: "none", border: "none", fontSize: 22, cursor: "pointer", lineHeight: 1 }} onClick={() => setProblemModal(null)}>&times;</button>
            </Modal.Header>
            <Modal.Body style={{ padding: "20px 24px", fontSize: "0.95rem", lineHeight: 1.7, color: "#333", maxHeight: "70vh", overflowY: "auto" }}>
              {problemModal?.text}
            </Modal.Body>
          </Modal>

          {/* Note modal */}
          <Modal show={noteModal} onHide={() => setNoteModal(false)} centered>
            <Modal.Header style={{ borderBottom: '1px solid #e9ecef' }}>
              <h5 className="mb-0" style={{ fontWeight: 700 }}>
                {selectedBooking?.booking_number
                  ? `Note — Booking #${selectedBooking.booking_number}`
                  : 'Booking Note'}
              </h5>
              <button type="button" style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', lineHeight: 1 }} onClick={() => setNoteModal(false)}>&times;</button>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px 24px' }}>
              <textarea
                className="form-control"
                rows={5}
                placeholder="Enter note..."
                value={noteText}
                onChange={(e) => setNoteText(e.target.value)}
              />
            </Modal.Body>
            <Modal.Footer style={{ borderTop: '1px solid #e9ecef' }}>
              <button
                className="btn"
                style={{ background: '#fff', border: '1px solid #d0d4e0', color: '#6b7088', borderRadius: 999, fontWeight: 600, padding: '6px 18px' }}
                onClick={() => setNoteModal(false)}
              >
                Cancel
              </button>
              <button
                className="btn"
                style={{ background: '#c22627', color: '#fff', border: '1px solid #c22627', borderRadius: 999, fontWeight: 600, padding: '6px 18px' }}
                onClick={saveNote}
              >
                Save Note
              </button>
            </Modal.Footer>
          </Modal>

          {/* Extra payment request modal */}
          <Modal show={extraPaymentModal} onHide={() => !sendingExtraPayment && closeExtraPaymentModal()} centered>
            <Modal.Header style={{ borderBottom: '1px solid #e9ecef' }}>
              <h5 className="mb-0" style={{ fontWeight: 700 }}>
                {extraPaymentTarget?.booking_number
                  ? `Payment Request — Booking #${extraPaymentTarget.booking_number}`
                  : 'Payment Request'}
              </h5>
              <button type="button" style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', lineHeight: 1 }} onClick={() => !sendingExtraPayment && closeExtraPaymentModal()} disabled={sendingExtraPayment}>&times;</button>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px 24px' }}>
              <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: '#2d3148', marginBottom: 6 }} htmlFor="extra-payment-amount">Amount (₹) *</label>
              <input
                id="extra-payment-amount"
                type="number"
                min="0"
                step="0.01"
                className="form-control"
                placeholder="Enter amount"
                value={extraPaymentAmount}
                onChange={(e) => setExtraPaymentAmount(e.target.value)}
                required
                style={{ marginBottom: 16 }}
              />
              <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: '#2d3148', marginBottom: 6 }} htmlFor="extra-payment-reason">Reason *</label>
              <textarea
                id="extra-payment-reason"
                className="form-control"
                rows={4}
                placeholder="e.g. Extra 12 min consultation time"
                value={extraPaymentReason}
                onChange={(e) => setExtraPaymentReason(e.target.value)}
                required
              />
            </Modal.Body>
            <Modal.Footer style={{ borderTop: '1px solid #e9ecef' }}>
              <button
                className="btn"
                style={{ background: '#fff', border: '1px solid #d0d4e0', color: '#6b7088', borderRadius: 999, fontWeight: 600, padding: '6px 18px' }}
                onClick={closeExtraPaymentModal}
                disabled={sendingExtraPayment}
              >
                Cancel
              </button>
              <button
                className="btn"
                style={{ background: '#c22627', color: '#fff', border: '1px solid #c22627', borderRadius: 999, fontWeight: 600, padding: '6px 18px', opacity: sendingExtraPayment ? 0.7 : 1, cursor: sendingExtraPayment ? 'not-allowed' : 'pointer' }}
                onClick={handleSendExtraPaymentRequest}
                disabled={sendingExtraPayment}
              >
                {sendingExtraPayment ? 'Sending…' : 'Send Request'}
              </button>
            </Modal.Footer>
          </Modal>

          {/* Cancel extra payment request confirm modal */}
          <Modal
            show={!!cancelPaymentTarget}
            onHide={() => !cancellingPayment && setCancelPaymentTarget(null)}
            centered
            backdrop="static"
          >
            <Modal.Header style={{ borderBottom: '1px solid #e9ecef' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ width: 40, height: 40, borderRadius: '50%', background: '#fdebec', color: '#c22627', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>
                  <i className="fas fa-exclamation-triangle" />
                </span>
                <h5 className="mb-0" style={{ fontWeight: 700 }}>Cancel payment request?</h5>
              </div>
              <button type="button" style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', lineHeight: 1 }} onClick={() => !cancellingPayment && setCancelPaymentTarget(null)} disabled={cancellingPayment}>&times;</button>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px 24px', fontSize: '0.95rem', color: '#333' }}>
              Are you sure you want to cancel the payment request of{' '}
              <strong style={{ color: '#1f2540' }}>₹{Number(cancelPaymentTarget?.amount ?? 0).toLocaleString('en-IN')}</strong>
              {' '}for booking <strong style={{ color: '#1f2540' }}>#{cancelPaymentTarget?.booking_number || ''}</strong>?
            </Modal.Body>
            <Modal.Footer style={{ borderTop: '1px solid #e9ecef' }}>
              <button
                className="btn"
                style={{ background: '#fff', border: '1px solid #d0d4e0', color: '#6b7088', borderRadius: 999, fontWeight: 600, padding: '6px 18px' }}
                onClick={() => setCancelPaymentTarget(null)}
                disabled={cancellingPayment}
              >
                Keep it
              </button>
              <button
                className="btn"
                style={{ background: '#c22627', color: '#fff', border: '1px solid #c22627', borderRadius: 999, fontWeight: 600, padding: '6px 18px', opacity: cancellingPayment ? 0.7 : 1, cursor: cancellingPayment ? 'not-allowed' : 'pointer' }}
                onClick={handleCancelPaymentRequest}
                disabled={cancellingPayment}
              >
                {cancellingPayment ? 'Cancelling…' : 'Cancel Request'}
              </button>
            </Modal.Footer>
          </Modal>
        </main>
      </div>
    </div>
  );
};

const mapDispatchToProps = { toggleLoader, getUserData };
const mapStateToProps = (state) => ({ userdata: state.userdata?.userData });
export default connect(mapStateToProps, mapDispatchToProps)(Bookings);
